export default async function action() {
  return {
    redirect: '/about',
    status: 301,
  };
}
